import { render, staticRenderFns } from "./Sobrecito.vue?vue&type=template&id=3a82b42c&"
import script from "./Sobrecito.vue?vue&type=script&lang=js&"
export * from "./Sobrecito.vue?vue&type=script&lang=js&"
import style0 from "./Sobrecito.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports